/**
 * Created by Ning Jiang on 2022-04-26.
 */

import {Serial} from "../Serial";
import {ReelPositionController} from "../reels/ReelPositionController";
import {Layers, SerialLayers} from "./SerialLayers";
import {gsap} from "gsap";
import {SerialGameAssets} from "../SerialGameAssets";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class EnhancerXNudgeOverlay extends PIXI.Container {

    public reelId:number;
    public symId:number;
    private _sym:PIXI.Sprite;
    private _symMask:PIXI.Graphics;
    private _multiplierContainer:PIXI.Container;
    private _multiplierText:PIXI.BitmapText;
    private _frameTop:PIXI.Sprite;
    private _frameBottom:PIXI.Sprite;
    private _spine:PIXI.spine.Spine;

    private _currentHeight:number;
    public get currentHeight():number {
        return this._currentHeight;
    }

    public set currentHeight(value) {
        if(value === this._currentHeight) {
            return;
        }

        this._currentHeight = value;
        this._sym.y = this._currentHeight * 0.5 * (this.symId > 1 ? -1 : 1);
        this._spine.y = this._sym.y;
        this._frameTop.y = this._sym.y - this._currentHeight * 0.5;
        this._frameBottom.y = this._sym.y + this._currentHeight * 0.5;
        this._multiplierContainer.y = this._sym.y + 50;
        this._symMask.height = this._currentHeight;
        this._symMask.y = this.symId > 1 ? -this._currentHeight : 0;
    }

    private _currentMultiplier:number = 0;
    public get currentMultiplier() {
        return this._currentMultiplier;
    }

    constructor(reelId:number, symId:number) {
        super();

        this.reelId = reelId;
        this.symId = symId;
        this._symMask = new PIXI.Graphics();
        this._symMask.beginFill(0x00FF00, 1);
        this._symMask.drawRect(-ReelPositionController.REEL_AREAS[reelId].width * 0.5, 0, ReelPositionController.REEL_AREAS[reelId].width, ReelPositionController.DEFAULT_SYMBOL_HEIGHT * 0.5);
        this._symMask.endFill();
        this.addChild(this._symMask);

        this._sym = new PIXI.Sprite(Serial.assetLoader.getTextures("WXN/WXN")[0]);
        this._sym.anchor.set(0.5);
        this.addChild(this._sym);
        this._sym.mask = this._symMask;

        this._spine = new PIXI.spine.Spine(Serial.assetLoader.getSpineAsset("xNudge"));
        this._spine.autoUpdate = true;
        this.addChild(this._spine);
        this._spine.mask = this._symMask;

        this._frameTop = new PIXI.Sprite(Serial.assetLoader.getTextures(`frames/WXN/top`)[0]);
        this._frameTop.anchor.set(0.5, 0);
        this._frameBottom = new PIXI.Sprite(Serial.assetLoader.getTextures(`frames/WXN/bottom`)[0]);
        this._frameBottom.anchor.set(0.5, 1);
        this.addChild(this._frameTop);
        this.addChild(this._frameBottom);

        this._multiplierContainer = new PIXI.Container();
        this.addChild(this._multiplierContainer);

        this._multiplierText = new PIXI.BitmapText("", {
            fontName : SerialGameAssets.BITMAP_FONT_NUDGE_MULTIPLIER,
            fontSize : 38,
            tint : 0xffffff
        });
        this._multiplierText.letterSpacing = -15;
        (<PIXI.Point>this._multiplierText.anchor).set(0.5);
        this._multiplierContainer.addChild(this._multiplierText);

        const position = Serial.getSymbol(reelId, symId).getGlobalPosition();
        this.position.set(position.x, symId > 1 ? (position.y + ReelPositionController.DEFAULT_SYMBOL_HEIGHT * 0.25) : (position.y - ReelPositionController.DEFAULT_SYMBOL_HEIGHT * 0.25));

        this.currentHeight = ReelPositionController.DEFAULT_SYMBOL_HEIGHT * 0.5;
        this.updateMultiplier(1, false);
    }

    public nudgeTo(targetHeight:number, stepDuration:number, stepEase:string):gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add([
            gsap.to(this, {currentHeight : targetHeight, duration : stepDuration, ease : stepEase}),
            () => {
                this._spine.state.setAnimation(0, "nudge", false);
            }
        ]);
        return tl;
    }

    public updateMultiplier(value:number, animate:boolean):gsap.core.Timeline {
        Logger.logDev(`wild update to multiplier ${value} on reel ${this.reelId}`);
        const tl = gsap.timeline();
        if(value === this.currentMultiplier) {
            return tl;
        }

        this._currentMultiplier = value;

        tl.add(() => {
            this._multiplierText.text = `X${value}`;
            if(value > 9) {
                this._multiplierText.letterSpacing = -25;
            }
        }, 0);

        if(animate) {
            // this._multiplierGlow.texture = TombstoneRip.assetLoader.getTextures(`wild/multiplier/x${value}`)[0];
            tl.add([
                gsap.to(this._multiplierContainer.scale, {x : 1.5, y : 1.3, duration : 0.1}),
                //     gsap.to(this._multiplierGlow, {alpha : 1, duration : 0.1})
            ]);
            tl.add([
                gsap.to(this._multiplierContainer.scale, {x : 1, y : 1, duration : 0.5}),
                //     gsap.to(this._multiplierGlow, {alpha : 0, duration : 0.5})
            ]);
        }

        return tl;
    }

    public splitSymbol():gsap.core.Animation {
        const tl = gsap.timeline();
        tl.add([
            this.updateMultiplier(this._currentMultiplier * 2, true),
            () => {
                this._spine.state.setAnimation(0, "split", false);
            }
        ]);
        return tl;
    }
}